<template>
    <v-container fluid>
        <SaralaTable
            :model="model"
            :createRoute="{ name: 'notifications.create' }"
        >
            <template #exibition="{ item }">
                {{ item.exibition }}
            </template>
            <template #status="{ item }">
                {{
                    item.status
                        ? $t('resources.default.active')
                        : $t('resources.default.inactive')
                }}
            </template>
        </SaralaTable>
    </v-container>
</template>

<script>
import Notification from '@/models/Notification'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new Notification()
        },
    },
}
</script>

<style></style>
